import React from 'react';
import './style.less';

export default function ({ className = "", style = {}, url }) {
    return (
        <div className={`com-blurImage ${className}`} style={style}>
            <div className="com-blurImage__bg" style={{ backgroundImage: `url(${url})` }}></div>
            <div className="com-blurImage__bg-bottom" style={{ backgroundImage: `url(${url})` }}></div>
            <div className="com-blurImage__bg-dark"></div>
        </div>
    )
}